/** CustomEvent name already dispatched by auth NeedHelp handlers. */
export const OPEN_CHAT_EVENT = 'sportsbook:open-chat';

export function dispatchOpenChat(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_CHAT_EVENT));
}
